import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_vehicle_inspection')
export class RmVehicleInspection {
    @PrimaryGeneratedColumn("increment", { name: 'inspection_id' })
    inspectionId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'vehicle_id'
    })
    vehicleId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_item_id'
    })
    grnItemId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "rmvi_number"
    })
    rmVINumber: string;

    @Column({
        nullable: false,
        name: "vehicle_in_time"
    })
    vehicleInTime: Date;

    @Column({
        type: 'int',
        nullable: false,
        name: 'indent_id'
    })
    indentId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_id'
    })
    grnId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'product_id'
    })
    varietyOfMaterial: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'supplier_id'
    })
    supplierId: number;

    

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "seal_number"
    })
    sealNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "icing_condition"
    })
    icingConditionOfMaterial: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "crates_condition"
    })
    cratesCondition: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "cleanliness_Of_crates"
    })
    cleanlinessOfCrates: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "vehicle_cleanliness"
    })
    vehicleCleanliness: string;


    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "sign_of_infestation"
    })
    anySignOfInfestation: string;


    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "dust_or_filth"
    })
    contaminationDustOrFilth: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "insulation_damage"
    })
    insulationDamage: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "remarks"
    })
    remarks: string;

    @Column({
        type: 'int',
        nullable: true,
        name: 'plant_id'
    })
    plantId: number;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}